/**
 * List Routes
 */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
// async components
import Lista from "./components/Lista";
import Cadastro from "./components/Cadastro";
// page title bar
// intl messages

const Pai = ({ match }) => (
  <div className="content-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
      <Route path={`${match.url}/list`} component={Lista} />
      <Route path={`${match.url}/:id`} component={Cadastro} />
    </Switch>
  </div>
);

export default Pai;
